import React, { Component } from 'react';

import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import find from 'lodash/find';

import ChooseResults from './ChooseResults';
import ThisOrThatResults from './ThisOrThatResults';
import RatableResults from './RatableResults';
import QAResults from './QAResults';
import AdjoyabilityDial from '../../../shared/components/AdjoyabilityDial';
import Button from '../../../shared/components/Button';
import Link from 'react-router-dom/NavLink';

import { formatDateRange, emojiUrlForRating } from '../../../shared/utils';

class CampaignResults extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      isShowingExportHelp:false
    };
  }

  componentDidMount(){
    if(this.props.engagements.length > 0 && this.props.engagementKPIs.length > 0){
      this.setState({isLoaded:true});
    } else {
      Promise.all([
        this.props.loadKPIsForCampaign(this.props.campaignId),
        this.props.loadEngagementsForCampaign(this.props.campaignId)
      ])
        .then(() => this.setState({isLoaded:true}))
        .catch((err) => this.handleFailure(err))
    }

  }

  handleFailure(err){}

  handlePrintClick(){
    window.print();
  }

  getSortedEngagementsAndKPIS(){
    return this.props.engagements
      .sort((a,b) => a.ordinal - b.ordinal)
      .map((engagement) => ({
        engagement:engagement,
        kpi:find(this.props.engagementKPIs, (k) => k.engagementId === engagement.id) || null
      }));
  }

  render(){
    const {
      campaignName,
      brandName,
      salesNumber,
      match,
      launchDate,
      endDate,
      totalCompletions,
      totalEngagements,
      averageTime,
      averageAdjoyability
    } = this.props;

    const { isLoaded } = this.state;

    const averageRating = this.props.averageAdjoyability || 0,
      responsesURL = match.url.slice(0,match.url.lastIndexOf('/')) + '/responses',
      reviewURL = match.url.slice(0,match.url.lastIndexOf('/')) + '/review';

    return (
      <Container className='CampaignResultsPrint'>
        <Row>
          <Col xs='8'>
            <br />
            <br />
            <h1>{campaignName}</h1>
            <h5>
              {brandName}
              &nbsp;&nbsp;
              <span style={{color:'#a5a5a5',fontSize:'1.1rem'}}>
                {formatDateRange(launchDate,endDate)}
              </span>
            </h5>
            <h5>Experience <strong>#{salesNumber}</strong></h5>
          </Col>
          <Col xs='4'>
            <br />
            <br />
            <Button
              className='no-print pull-right'
              onClick={() => this.handlePrintClick()}
            >
              <i className='fa fa-print' aria-hidden='true'></i>
              &nbsp;&nbsp;
              Export
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12' className='print-only'>
            <br />
            <hr />
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12' className='no-print'>
            <br />
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={responsesURL}
                  activeClassName='active'
                >
                  Consumer Responses
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={reviewURL}
                  activeClassName='active'
                >
                  Details
                </NavLink>
              </NavItem>
            </Nav>
            <br />
          </Col>
        </Row>
        <Row className='CampaignStats print-only'>
          <Col xs='3' className='data-column'>
            <h2>
              <i className='fa fa-2x fa-check' aria-hidden='true'></i>
              &nbsp;&nbsp;
              {(totalCompletions || 0).toLocaleString()}
            </h2>
            <h6>Completed Experiences</h6>
            <p>Experiences consumers have completed to date.</p>
          </Col>
          <Col xs='3' className='data-column'>
            <h2>
              <i className='fa fa-2x fa-commenting' aria-hidden='true'></i>
              &nbsp;&nbsp;
              {totalEngagements}
            </h2>
            <h6>Completed Activities</h6>
            <p>Total activities completed to date.</p>
          </Col>
          <Col xs='3' className='data-column'>
            <h2>
              <i className='fa fa-2x fa-clock-o' aria-hidden='true'></i>
              &nbsp;&nbsp;
              {Math.ceil(averageTime)} sec
            </h2>
            <h6>Average Time Spent in Experience</h6>
            <p>Average amount of time consumers have spent in this experience.</p>
          </Col>
          <Col xs='3' className='data-column'>
          {totalCompletions > 0 ? (
            <h2>
              <img
                style={{marginBottom:5,width:28}}
                src={emojiUrlForRating(averageRating)}
                alt='Adjoyability Emoji'
              />
              &nbsp;&nbsp;
              {(averageRating + 1).toFixed(2)}
            </h2>
          ) : (
            <h2>N/A</h2>
          )}
            <h6>Average Rating</h6>
            <p>Average rating given by users who have viewed the experience</p>
          </Col>
        </Row>

        <Row className='CampaignStats no-print'>
          <Col xs='8'>
            <br />
            <br />
            <Row>
              <Col xs='4' className='data-column'>
                <h2>
                  <i className='fa fa-2x fa-check' aria-hidden='true'></i>
                  &nbsp;&nbsp;
                  {(totalCompletions || 0).toLocaleString()}
                </h2>
                <h6>Completed Experiences</h6>
                <p>Experiences consumers have completed to date.</p>
              </Col>
              <Col xs='4' className='data-column'>
                <h2>
                  <i className='fa fa-2x fa-commenting' aria-hidden='true'></i>
                  &nbsp;&nbsp;
                  {(totalEngagements || 0).toLocaleString()}
                </h2>
                <h6>Completed Activities</h6>
                <p>Total activities completed to date.</p>
              </Col>
              <Col xs='4' className='data-column'>
                <h2>
                  <i className='fa fa-2x fa-clock-o' aria-hidden='true'></i>
                  &nbsp;&nbsp;
                  {Math.ceil(averageTime)} sec
                </h2>
                <h6>Average Time Spent in Experience</h6>
                <p>Average time users have spent engaging with you.</p>
              </Col>
            </Row>
          </Col>
          <Col xs='4'>
            <div style={{
              width:320,
              marginLeft:'auto',
              marginRight:'auto',
              textAlign:'center',
              color:'black'
            }}>
              <AdjoyabilityDial
                width={320}
                rating={averageAdjoyability}
              />
              <h6>
                Average Rating
                <br />
                of this Experience
              </h6>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <br />
            <hr />
          </Col>
        </Row>
        {isLoaded && this.getSortedEngagementsAndKPIS().map((engagementAndKPI) => {
          const e = engagementAndKPI.engagement,
            k = engagementAndKPI.kpi;

          if(!e || !k) return null;

          if(e.kind === 'choose'){
            return (
              <ChooseResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
          }

          if(e.kind === 'this_or_that'){
            return (
              <ThisOrThatResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
           }

          if(e.kind === 'ratable'){
            return (
              <RatableResults
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
          };

          if(e.kind === 'qa'){
            return (
              <QAResults 
                key={e.id}
                engagement={e}
                engagementKPIs={k}
              />
            )
          }

          return null;
        })}
        <Row>
          <Col xs='12'>
            <br />
            <br />
            <img
              className='print-only'
              src={require('../../../shared/assets/dabbl-logo.png')}
              alt='Dabbl Logo'
              style={{
                width:75,
                marginLeft:'auto',
                marginRight:'auto',
                display:'block'
              }}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default CampaignResults;



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/components/CampaignResultsPrint.js